var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalcony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2822_26326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56566 15.1393H2.10118C1.88747 15.1393 1.71423 14.9661 1.71423 14.7524V14.7524C1.71423 14.5386 1.88747 14.3654 2.10118 14.3654H6.3428M3.56566 15.1393V21.2857C3.56566 21.838 4.01338 22.2857 4.56566 22.2857H6.3428M3.56566 15.1393H6.3428M20.7428 15.1393H21.8987C22.1124 15.1393 22.2857 14.9661 22.2857 14.7524V14.7524C22.2857 14.5386 22.1124 14.3654 21.8987 14.3654H17.8628M20.7428 15.1393V21.2857C20.7428 21.838 20.2951 22.2857 19.7428 22.2857H17.8628M20.7428 15.1393H17.8628M12.1542 15.1393V22.2857M12.1542 15.1393H9.24852M12.1542 15.1393H15.0085M12.1542 22.2857H9.24852M12.1542 22.2857H15.0085M17.8628 15.1393V22.2857M17.8628 15.1393H15.0085M17.8628 22.2857H15.0085M6.3428 15.1393V22.2857M6.3428 15.1393H9.24852M6.3428 22.2857H9.24852M9.24852 15.1393V22.2857M15.0085 15.1393V22.2857M6.3428 7.12372V6.73741C6.51423 5.03128 7.91652 1.63833 12.1542 1.71559C16.0908 1.71559 17.5821 4.97297 17.8523 6.66815C17.8598 6.71505 17.8628 6.76124 17.8628 6.80873V7.12372M6.3428 7.12372H12.1028M6.3428 7.12372V11.1315V14.3654M17.8628 7.12372H12.1028M17.8628 7.12372V10.5514V14.3654M12.1028 7.12372L12.1285 11.1315L12.1028 14.3654M6.3428 14.3654H12.1028M12.1028 14.3654H17.8628",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2822_26326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcony);
export default __webpack_public_path__ + "static/media/balcony.0594dc544adff4861b996448132e2199.svg";
export { ForwardRef as ReactComponent };